import { useMutation } from 'react-query'
import { get } from 'framework/api/http'

interface GetUserDetailsByEmailTokenInterface {
  token?: number | string
}

export const useGetUserDetailsByEmailToken = () => {
  const mutate = useMutation((token: GetUserDetailsByEmailTokenInterface) => {
    return get(`/account/GetUserDetailsByEmailToken?token=${token}`)
  })

  return mutate
}

export default useGetUserDetailsByEmailToken
